import { render, staticRenderFns } from "./ApiTokenList.vue?vue&type=template&id=23f3efa3&"
import script from "./ApiTokenList.vue?vue&type=script&lang=js&"
export * from "./ApiTokenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports